<template>
  <div id="footerBox" class="fixed-bottom">
    <div id="footer">
      <!-- the expand bit is vital to cause it to be inline -->
      <nav class="navbar  navbar-expand-sm">
        <span id="notice" class="navbar-brand  text-wrap">All screenplays &copy; of the author(s). All right Reserved</span>

        <div class="navbar-nav">
          <!-- anchor tags are fatal to the session, so use router links -->
          <RouterLink to="policies" class="nav-item active">Policies</RouterLink>
          <RouterLink to="contact" class="nav-item">Contact</RouterLink>
          <a
              href="https://www.youtube.com/channel/UCXTKEMG8k66nYpI5EbCztKw"
              class="nav-item youtube-icon" target="_blank" rel="noopener" title="YouTube Channel">
            <svg height="24" viewBox="0 0 40 16" width="60" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor"
                    d="m5.375 2.647c.003-.014.005-.023.006-.028l.016-.118-.74-.004c-.668-.004-.873 0-.891.017-.009.008-.24.885-.651 2.473-.196.758-.361 1.363-.367 1.345s-.24-.883-.522-1.922c-.281-1.039-.517-1.894-.524-1.901-.01-.01-.906-.014-1.632-.008-.105.001-.164-.205.938 3.299.152.485.381 1.172.507 1.526.146.408.25.724.321.987.126.501.13.815.103 1.182-.032.423-.036 3.413-.005 3.463.024.038 1.425.056 1.558.02.021-.006.035-.026.045-.139.033-.097.036-.484.036-2.09v-2.051l.09-.283c.059-.185.206-.672.328-1.082s.269-.9.327-1.09c.529-1.724 1.033-3.419 1.047-3.516l.011-.079z"/>
              <path fill="currentColor"
                    d="m13.221 5.135v.107h-.017l-.009 2.953-.009 2.863-.229.233c-.257.261-.462.361-.648.314-.203-.051-.197.028-.214-3.356l-.016-3.115h-1.474v.107h-.017v3.38c0 3.621 0 3.619.184 3.982.146.29.36.431.725.479.481.064 1-.154 1.481-.622l.209-.203v.351c0 .303.009.353.064.368.09.025 1.206.027 1.326.002l.1-.021v-.104l.017-.003v-7.736l-1.472.02z"/>
              <path fill="currentColor"
                    d="m9.483 6.661c-.14-.599-.401-1.002-.832-1.28-.676-.437-1.449-.484-2.165-.13-.522.258-.859.686-1.032 1.314-.021.075-.036.138-.047.231-.044.222-.049.552-.061 2.093-.018 2.374.01 2.656.307 3.195.292.529.897.917 1.556.997.198.024.6-.013.832-.078.525-.146 1.029-.561 1.252-1.032.096-.204.154-.345.189-.604.065-.353.07-.925.07-2.381 0-1.857-.006-2.06-.068-2.326zm-1.681 4.839c-.124.094-.34.135-.515.098-.135-.029-.318-.241-.374-.434-.07-.241-.075-3.594-.015-4.251.1-.329.378-.501.682-.419.237.064.358.212.427.523.051.231.057.518.046 2.207-.007 1.12-.011 1.668-.048 1.962-.037.185-.099.235-.203.315z"/>
              <path fill="currentColor"
                    d="m35.944 8.346h.712l-.011-.645c-.011-.592-.02-.659-.099-.82-.125-.253-.309-.366-.601-.366-.351 0-.573.17-.678.518-.045.148-.092 1.167-.058 1.255.019.049.121.058.735.058z"/>
              <path fill="currentColor"
                    d="m31.184 6.879c-.095-.191-.272-.286-.477-.278-.16.006-.337.073-.508.203l-.127.097v4.634l.127.097c.288.22.604.266.822.12.086-.058.142-.137.186-.263.057-.164.062-.375.055-2.325-.008-2.032-.012-2.152-.078-2.285z"/>
              <path fill="currentColor"
                    d="m40.014 4.791c-.142-1.701-.255-2.253-.605-2.962-.465-.939-1.136-1.434-2.092-1.543-.739-.084-3.521-.203-6.094-.26-4.456-.099-11.782.092-12.718.331-.432.111-.757.299-1.094.634-.591.588-.944 1.432-1.085 2.6-.323 2.666-.33 5.886-.019 8.649.134 1.188.41 1.96.928 2.596.323.397.881.734 1.379.835.35.071 2.1.169 4.65.26.38.014 1.385.037 2.235.052 1.77.031 5.025.013 6.886-.039 1.252-.035 3.534-.128 3.961-.161.12-.009.398-.027.618-.039.739-.042 1.209-.196 1.65-.543.571-.449 1.013-1.278 1.2-2.251.177-.92.295-2.559.319-4.42.02-1.555-.007-2.393-.119-3.741zm-17.744-.616-.828.01-.036 8.83-.718.009c-.555.008-.724-.001-.737-.036-.01-.025-.021-2.016-.026-4.424l-.009-4.379-1.617-.02v-1.38l4.779.019.02 1.36-.828.01zm5.077 5.061v3.797h-1.308v-.4c0-.301-.011-.4-.047-.4-.026 0-.144.099-.263.22-.259.263-.565.474-.827.572-.542.203-1.056.084-1.275-.293-.201-.345-.204-.423-.204-4.005v-3.29h1.307l.01 3.098c.01 3.044.011 3.1.084 3.224.097.164.244.209.478.144.138-.038.232-.105.455-.327l.282-.28v-5.859h1.308v3.797zm5.102 3.255c-.115.257-.372.508-.583.57-.549.162-.99.03-1.499-.449-.158-.149-.305-.269-.327-.269-.027 0-.041.116-.041.345v.345h-1.308v-10.248h1.308v1.672c0 .919.012 1.672.027 1.672s.153-.122.307-.27c.354-.341.649-.491 1.024-.519.669-.051 1.068.294 1.25 1.08.057.245.062.525.062 2.798 0 2.768 0 2.78-.221 3.273zm5.535-1.52c-.012.285-.046.612-.077.727-.182.674-.666 1.152-1.366 1.348-.942.264-1.98-.168-2.394-.997-.232-.465-.241-.558-.241-2.831 0-1.853.007-2.081.066-2.334.168-.715.584-1.178 1.289-1.435.204-.074.417-.113.63-.117.761-.016 1.515.393 1.832 1.059.213.449.24.642.261 1.908l.019 1.136-2.789.019-.01.763c-.015 1.077.058 1.408.349 1.603.244.165.62.152.824-.027.192-.168.246-.349.265-.877l.017-.463h1.347z"/>
            </svg>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "SecondaryNav",
}
</script>

<style lang="scss">
@use "@/assets/styles/livery" as *;

#footerBox {
  font-family: branded-font, "Times New Roman", Times, serif;
  background-color: $colour-banner-background;

  #footer {
    border-top: $pin-stripe-width $pin-stripe-style $colour-page-background;
    margin-top: $margin-furniture;
  }

  .navbar-nav {
    margin-left: auto;
    margin-right: 0.5em;
    padding-right: 1em;

    .nav-item {
      color: $colour-banner-primary-text;
    }
  }

  // in reasonably sized viewports, this will look OK
  #notice {
    color: $colour-banner-primary-text;
    font-size: small;
    float: left;
    margin-left: 1rem;
  }
  // On small phones, we have a problem with this notice forcing the nav down.
  // this makes it wrap, which is OK, because the nav-bar is taking quite a few lines
  @media (max-width: 390px) {
    #notice {
      white-space: normal !important;
      word-break: break-word;
      min-width: 0 !important;
      max-width: 50% !important;
      flex-shrink: 1 !important;
    }
    /* If #notice is inside a flex container, make sure the parent allows shrinking: */
    .navbar-nav {
      flex-wrap: nowrap !important;
      min-width: 0 !important;
    }
  }

  .youtube-icon {
    height: 1.75em;
    width: auto; // maintains aspect ratio
    vertical-align: middle;
    display: inline-block;
  }
}

</style>
